import AppointmentComposeAdapter from './adapters/AppointmentComposeAdapter';
import CommonAdapter from './adapters/CommonAdapter';
import MessageComposeAdapter from './adapters/MessageComposeAdapter';
import MessageReadAdapter from './adapters/MessageReadAdapter';
import TaskPaneAdapter from './adapters/TaskPaneAdapter';
import { ExtApiParams, OsfExtApiParams } from './apis/ApiParams';
import {
    AttachmentDetails,
    TypeOfAttachment,
    createAttachmentDetails,
} from './apis/attachments/AttachmentDetails';
import AppendOnSend from './apis/body/AppendOnSend';
import GetInitialData from './apis/getInitialData/getInitialData';
import InitialData from './apis/getInitialData/InitialData';
import InternetHeaders from './apis/internetHeaders/InternetHeaders';
import { ExtensibilityNotification } from './apis/notification/ExtensibilityNotification';
import RecipientField from './apis/recipients/RecipientFieldEnum';
import AttachmentStatusEnum from './apis/attachments/AttachmentStatusEnum';
import { SelectedData } from './apis/selectedData/SelectedData';
import { CoercionType } from './apis/setData/CoercionType';

export { addAdapter, deleteAdapter, getAdapter } from './adapters/AdapterManager';
export { default as LocationDetails } from './apis/location/LocationDetails';
export { createLocationDetails } from './apis/location/enhancedLocationsUtils';
export {
    default as addOrReplaceNotificationMessage,
} from './apis/notification/addOrReplaceNotificationMessage';
export { default as convertHtmlToPlainText } from './utils/convertHtmlToPlainText';
export {
    default as closeTaskPaneAddinCommandByControlId,
} from './utils/closeTaskPaneAddinCommandByControlId';
export { createAdapter as createMockAdapter } from './test/mockData/MockAdapter';
export {
    destroyExtensibilityNotifications,
} from './apis/notification/ExtensibilityNotificationManager';
export { default as doesItemExist } from './utils/doesItemExist';
export { default as evaluateRegularExpression } from './utils/evaluateRegularExpression';
export { default as executeApiMethod } from './apis/executeApiMethod';
export { default as getEntityExtractionResult } from './services/getEntityExtractionResult';
export { default as getExtensibilityContext } from './services/getExtensibilityContext';
export { getUserTypeString } from './utils/UserType';
export {
    default as initializeExtensibilityNotifications,
} from './apis/notification/initializeExtensibilityNotifications';
export {
    default as removeNotificationMessage,
} from './apis/notification/removeNotificationMessage';

export {
    AppendOnSend,
    AppointmentComposeAdapter,
    AttachmentDetails,
    AttachmentStatusEnum,
    CoercionType,
    CommonAdapter,
    createAttachmentDetails,
    ExtApiParams,
    ExtensibilityNotification,
    GetInitialData,
    InitialData,
    InternetHeaders,
    MessageComposeAdapter,
    MessageReadAdapter,
    OsfExtApiParams,
    RecipientField,
    SelectedData,
    TaskPaneAdapter,
    TypeOfAttachment,
};
